import React, { useState } from "react";
import Aside from "../modules/SideNav/Aside";
import ProjectGrading from "../components/Programs/ProjectGrading/ProjectGrading";

const ProjectGradingLayout = () => {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <ProjectGrading handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
};

export default ProjectGradingLayout;
